import { Select } from '@thoughtspot/radiant-react/widgets/select';
import React, { useCallback } from 'react';
import styles from './select-input.module.scss';
export const SelectInput = ({ value, options, onChange, searchable, placeholder, disabled, }) => {
    const handleChange = useCallback((data) => {
        const selected = Array.isArray(data) ? data[0] : data;
        if (selected) {
            onChange(selected.id);
        }
    }, [onChange]);
    return (React.createElement("div", { className: styles.selectWrapper },
        React.createElement(Select.Dropdown, { optionsGroups: [{ options: options }], selectedOptions: value ? [value] : [], onChange: handleChange, placeholder: placeholder, isSearchEnabled: searchable, disabled: disabled })));
};
//# sourceMappingURL=select-input.js.map